import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';
import { FieldEditChangedArgs } from 'src/cer/cer-data/cer-data-types';

export class ProductBudgetCategoryForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'udgivelse-arter', dataApiName: 'ProductBudgetCategory', text: 'Arter, udgivelser',
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'sorting', 'history']
      },
      fieldMetadata: [
        { name: 'isPrimary', text: 'Primær samarbejdsaftaler', tooltipText: 'Skal denne art tilknyttes automatisk for samarbejdsaftaler', format: 'CheckBox', defaultValue: true },
        { name: 'isBudget', text: 'Budget', format: 'CheckBox', defaultValue: true },
        { name: 'defaultAmount', text: 'Beløb standard', format: 'Amount' },
        { name: 'defaultPercentage', text: '% standard', format: 'Amount' },
        {
          name: 'legacyId', text: 'Oprindelig art', tooltipText: 'Reference til oprindelig database', required: true,
          foreignKeyTableName: 'OmkArter', foreignKeyField: 'id', foreignKeyValue: 'omkArt', foreignKeyColumns: ['omkArt', 'oaid'], foreignKeyTitles: ['Navn', 'Art'],
          foreignKeySortFields: ['sortering', 'omkArt'], onEditChanged: (args) => { this.editChangedLegacyId(args) }
        },
        { name: 'sorting', text: 'Sortering', format: 'Integer', orderBy: 'Ascending' }

      ]
    });
  }

  private editChangedLegacyId(e: FieldEditChangedArgs) {
    var omkArt: any = e.itemData;
    if (omkArt) {
      var numValue: string = omkArt.oaid;
      var nameValue: string = omkArt.omkArt;
      var defaultAmountValue: number = omkArt.defaultUI;
      var sortingValue: number = omkArt.sortering;

      var edit = e.editService;
      var numInput = edit.fieldInput('num');
      var nameInput = edit.fieldInput('name');
      var defaultAmountInput = edit.fieldInput('defaultAmount');
      var sortingInput = edit.fieldInput('sorting');

      if (numInput && !(numValue.length > 0)) {
        edit.inputValueSet(numInput, numValue);
      }
      if (nameInput && (nameValue?.length > 0)) {
        edit.inputValueSet(nameInput, nameValue);
      }
      if (defaultAmountInput && defaultAmountValue >= 1) {
        edit.inputValueSet(defaultAmountInput, defaultAmountValue);
      }
      if (sortingInput && sortingValue != 0) {
        edit.inputValueSet(sortingInput, sortingValue);
      }
    }
  }
}
